<template>
  <el-dialog title='报表批量打印' class='default-dialog' :visible.sync="isShow" :close-on-click-modal="false" @open = "open"
    width='600px'>
    <el-form ref="form" :model="form">
      <el-form-item label="打印报表：" label-width="90px">
        <el-checkbox-group v-model="form.types">
          <el-checkbox v-for="(item, index) in chooseData" :key="index" :label = "item.value" >{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="期间：" label-width="90px">
        <accounting-period ref="accountingPeriod" @defaultTime='defaultTime'></accounting-period>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" class="secondaryButton" @click = "isShow = false">取 消</el-button>
      <el-button size="small" class='minButton' @click = "submitPrint">打 印</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import accountingPeriod from '@/components/dialog/accountingPeriod'
  export default {
    props: {
      showVisible: Boolean,
    },
    components: {
			accountingPeriod
		},
    data() {
      return {
        chooseData: [],
        form: {
          types: [],
          startYearPeriods: "",
          endYearPeriods: "",
        }
      }
    },
    computed: {
      isShow: {
        get () {
          return this.showVisible;
        },
        set (val) {
          this.$emit('update:showVisible', val);
        }
      }
    },
    methods: {
      submitPrint() {
        console.log(this.form);
        this.$emit('submitPrint', { ...this.form, types: this.form.types.join(',') });
        this.isShow = false;
      },
      async open() {
        // 判断是不是民办非
        const IsPrivateNonProfit = await this.$store.dispatch("getIsPrivateNonProfit", {})
        if(IsPrivateNonProfit) {
          this.chooseData = [ { name: "资产负债", value: 1 },{ name: "业务活动", value: 3 } ]
          this.form.types = [1,3]
        }else {
          this.chooseData = [ { name: "资产负债", value: 1 },{ name: "利润表（月报）", value: 2 }, { name: "现金流量表（公式法）", value: 4 } ]
          this.form.types = [1,2,4]
        }
      },
      // 接收会计期间数据
			defaultTime(data) {
				this.form = Object.assign(this.form,{
					startYearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
					endYearPeriods:  this.$util.formatDate.format(data.yearPeriodsEnd , 'yyyyMM'),
				});
			}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/print/continuityDialog.vue